import React, { Component } from 'react';
import styles from './styles.module.css';

import ItemLink from '../../../components/item-link';

class ResultItem extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    if (this.props.observer) {
      this.props.observer.observe(this.ref.current);
    }
  }

  componentWillUpdate(nextProps) {
    if (!this.props.observer && !!nextProps.observer) {
      nextProps.observer.observe(this.ref.current);
    } else if (!nextProps.observer && !!this.props.observer) {
      this.props.observer.unobserve(this.ref.current);
    }
  }

  render() {
    return (
      <li ref={this.ref} className={styles.item}>
        <ItemLink
          id={this.props.id}
          imageSizes="(min-width: 1024px) 280px, (min-width: 768px) calc(33vw - 3rem), calc(50vw - 4rem)"
        />
      </li>
    );
  }
}

export default class ResultList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      observer: null
    };
  }

  componentDidMount() {
    this.setState({
      observer: new IntersectionObserver(this.observed, {
        root: null,
        rootMargin: '0px',
        threshold: 0
      })
    });
  }

  observed = entries => {
    if (entries[0] && entries[0].isIntersecting) {
      this.props.showMore();
    }
  };

  render() {
    return (
      <ul className={styles.container}>
        {this.props.objects.map((object, index) => (
          <ResultItem
            key={object.id}
            {...object}
            observer={
              index === this.props.objects.length - 1
                ? this.state.observer
                : null
            }
          />
        ))}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/page-components/glass/result-list/index.js